import { EyeIcon } from "@heroicons/react/24/outline";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, TableCell, TableRow, useDisclosure } from "@nextui-org/react";
import { month } from "../../../../../services/enum";
import ClientTablePagination from "../../../../elements/ClientTablePagination";
import { format } from "date-fns";
import { formattedDate } from "../../../../../services/helpers";

export default function ModalDetailPurchase({ item }) {
    const {isOpen, onOpen, onOpenChange} = useDisclosure();
    const headerSupplier = ['Nama Perusahaan', 'Alamat Kantor', 'Jumlah Pembelian']
    const headerImport = ['Pelabuhan Bongkar', 'Tanggal Surat Impor', 'Jumlah Pembelian']

    const contentSupplier = (item) => (
        <TableRow key={item?.dataSupplier?.id}>
            <TableCell>{item?.dataSupplier?.namaSupplier}</TableCell>
            <TableCell>{item?.dataSupplier?.alamat}</TableCell>
            <TableCell>{item?.jumlahBahanB3Dibeli} Kg</TableCell>
        </TableRow>
    )
    const contentImport = (item) => (
        <TableRow key={item?.id}>
            <TableCell>{item?.pelabuhanBongkar?.nm_kantor_pendek} - {item?.pelabuhanBongkar?.nm_lokasi}</TableCell>
            <TableCell>{item?.tanggalSuratPdb ? formattedDate(item?.tanggalSuratPdb): '-'}</TableCell>
            <TableCell>{item?.jumlahBahanB3Dibeli} Kg</TableCell>
        </TableRow>
    )

    return (
        <>
            <Button isIconOnly size="sm" color="primary" onPress={onOpen}><EyeIcon className="size-4" /></Button>
            <Modal scrollBehavior="inside" size="2xl" isOpen={isOpen} onOpenChange={onOpenChange}>
                <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">Detail Laporan Pembelian</ModalHeader>
                        <ModalBody>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <div className='flex flex-col'>
                                    <span className='text-xs text-ink-400 uppercase'>Perusahaan</span>
                                    <span className='text-sm font-medium'>{item.company.name}</span>
                                </div>
                                <div className='flex flex-col'>
                                    <span className='text-xs text-ink-400 uppercase'>Periode</span>
                                    <span className='text-sm font-medium'>{item.period.name}</span>
                                </div>
                                <div className='flex flex-col'>
                                    <span className='text-xs text-ink-400 uppercase'>Bulan</span>
                                    <span className='text-sm font-medium'>{month[item.bulan-1]}</span>
                                </div>
                                <div className='flex flex-col'>
                                    <span className='text-xs text-ink-400 uppercase'>Tahun</span>
                                    <span className='text-sm font-medium'>{item.tahun}</span>
                                </div>
                                <div className='flex flex-col'>
                                    <span className='text-xs text-ink-400 uppercase'>Jenis B3</span>
                                    <span className='text-sm font-medium'>{item?.dataBahanB3?.namaBahanKimia ?? '-'}</span>
                                </div>
                                <div className='flex flex-col'>
                                    <span className='text-xs text-ink-400 uppercase'>Jumlah Pembelian</span>
                                    <span className='text-sm font-medium'>{item?.jumlahPembelianB3} Kg</span>
                                </div>
                                <div className='flex flex-col'>
                                    <span className='text-xs text-ink-400 uppercase'>Tipe Pembelian</span>
                                    <span className='text-sm font-medium'>{item?.tipePembelian}</span>
                                </div>
                                {
                                    item?.tipePembelian === 'Lokal' 
                                    ?
                                    <div className="col-span-2">
                                        <ClientTablePagination 
                                            content={contentSupplier} 
                                            header={headerSupplier} 
                                            data={item?.DataSupplierOnPelaporanPembelianBahanB3} 
                                        />
                                    </div>
                                    :
                                    <div className="col-span-2">
                                        <ClientTablePagination 
                                            content={contentImport} 
                                            header={headerImport} 
                                            data={item?.DataImportOnPelaporanPembelianBahanB3} 
                                        />
                                    </div>

                                }
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" variant="light" onPress={onClose}>
                                Tutup
                            </Button>
                        </ModalFooter>
                    </>
                )}
                </ModalContent>
            </Modal>
        </>
    )
}
